import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetDefaultSubcontractors = async (serviceOfferingID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        serviceOfferingID: serviceOfferingID,
      }).toString();

      const response = await fetch(
        `${dev_baseUrl}/Service/getDefaultSubcontractors?${queryParams}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};

export const SaveDefaultSubcontractor = async (serviceOfferingID, subcontractor, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        defaultJobSubcontractorID: subcontractor.defaultJobSubcontractorID || 0,
        serviceOfferingID: serviceOfferingID,
        employeeID: subcontractor.employeeID,
        skillID: subcontractor.skillID,
        unitID: subcontractor.unitID,
        unitQuantity: subcontractor.unitQuantity,
        costPerUnit: subcontractor.costPerUnit,
        pricePerUnit: subcontractor.pricePerUnit,
        markup: subcontractor.markup,
      };

      const response = await fetch(`${dev_baseUrl}/Service/saveDefaultSubcontractor`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

export const DeleteDefaultSubcontractor = async (defaultJobSubcontractorID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/Service/deleteDefaultSubcontractor/${defaultJobSubcontractorID}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};
